import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Community Memorial Healthcare',
    frontend: 'https://cmh.mybenefitsnow.com',
    apiHash: 'https://cmh.mybenefitsnow.com/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'cmh-prod-frontend',
        'tenant-id': 'ee1f3a51-0fbf-4ebd-b1ca-c41e025d820c',
        'consumer-id': 'd9c875ed-1b2e-43a3-bfc0-513ae533c898',
    },
    commitSHA: '1664030',
    provider: 'cmh-prod-frontend',
    gtm: 'GTM-P2SN8X7P',
  cookiePolicy: 'a57e434e',
showNotifications: false,
    multilingual: false,
    colors: {
        primary: '#0057a5',
        secondary: '#b7d433',
    },
    readabilityEnabled: false,
    articlesParentRoute: 'news',
    imagery: {
        logo: 'https://storage.googleapis.com/archipelago-assets/cmh-logo.png',
        logoInverted: 'https://storage.googleapis.com/archipelago-assets/cmh-logo.png',
        logoTransparent: 'https://storage.googleapis.com/archipelago-assets/cmh-logo.png',
    },
    copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.' + ' Powered by Core.',
    demoMode: false,
    chatEnabled: false,
    contactEnabled: false,
    isDarkModeEnabled: false,
    postsLabel: 'news',
    coreLinkify: true,
    navigation: {
        navType: 'top',
        headerStyle: 'solid',
        style: 'default',
        categoryNav: false,
        navigationOrder: 'displayOrder',
    },
    pwa: {
        enabled: false,
        notifications: false,
    },
    enableSSR: false,
} as CONFIG; 
